<template>
  <div v-if="isWeixinEnv">
    <!-- 1. 底部横幅（加大 z-index 或者用 v-show 隐藏） -->
    <div class="guide-banner" v-show="!showPopup" @click="showPopup = true">
      <div class="banner-text">✨ 小程序体验更佳，点击前往</div>
      <div class="banner-icon">></div>
    </div>

    <!-- 2. 底部弹窗 -->
    <van-popup 
      v-model="showPopup" 
      position="bottom" 
      round 
      :z-index="99999" 
      class="guide-popup"
      :safe-area-inset-bottom="true"
    >
      <div class="popup-inner">
        <div class="drag-bar"></div>
        
        <div class="title">长按识别，前往小程序</div>
        <div class="desc">体验完整功能、查看专属报价</div>
        
        <!-- 二维码区域 -->
        <div class="qrcode-wrapper">
          <img src="https://assistant.lefonshop.cn/public/images/default/miniprogram-qrcode.png" alt="小程序码" />
        </div>
        
        <div class="close-btn" @click="showPopup = false">我知道了</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "MiniProgramGuide",
  data() {
    return {
      isWeixinEnv: false,
      showPopup: false
    };
  },
  mounted() {
    const ua = navigator.userAgent.toLowerCase();
    this.isWeixinEnv = ua.indexOf("micromessenger") !== -1;
  }
};
</script>

<style scoped>
/* ================= 底部横幅 ================= */
.guide-banner {
  position: fixed;
  left: 0;
  right: 0;
  /* 默认在底部导航栏上方 */
  bottom: calc(55px + constant(safe-area-inset-bottom));
  bottom: calc(55px + env(safe-area-inset-bottom));
  z-index: 9999;
  background: #e8f8eb; 
  color: #07c160; 
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  border-top: 1px solid #d1f2d9;
  border-bottom: 1px solid #d1f2d9;
  cursor: pointer;
}
.banner-icon { font-weight: bold; font-size: 16px; }

/* ================= 弹窗整体样式 ================= */
/* 强制弹窗宽度 100%，避免右侧被裁 */
.guide-popup {
  width: 100vw !important;
  left: 0 !important;
  right: 0 !important;
  margin: 0 auto !important;
  background: #ffffff !important;
  border-radius: 20px 20px 0 0 !important;
  padding: 0 !important; 
}

.popup-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* 加上 box-sizing 防止 padding 撑破 100vw 的宽度 */
  box-sizing: border-box; 
  width: 100%;
  padding: 15px 24px 30px;
  padding-bottom: calc(30px + env(safe-area-inset-bottom)); 
}

.drag-bar {
  width: 40px;
  height: 4px;
  background: #e0e0e0;
  border-radius: 2px;
  margin-bottom: 20px;
}

.title {
  font-size: 22px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 8px;
  text-align: center;
}

.desc {
  font-size: 14px;
  color: #999;
  margin-bottom: 25px;
  text-align: center;
}

/* 二维码区域 */
.qrcode-wrapper {
  width: 200px;
  height: 200px;
  background: #fff;
  border-radius: 12px;
  /* 去掉外层阴影，改用边框，防止被裁剪 */
  border: 1px solid #eaeaea; 
  padding: 8px;
  box-sizing: border-box;
  margin-bottom: 30px;
}

.qrcode-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: contain; 
  display: block;
}

/* 我知道了按钮 */
.close-btn {
  width: 100%;
  height: 50px;
  background: #f5f5f5;
  color: #333;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 10px;
}

.close-btn:active {
  background: #e8e8e8;
}
</style>